'use strict';

const { h } = require('phy');
const { pruneData } = require('../../../modules/support/prune-data.js');

const CouponUber = require('./coupon-uber');
const CouponTile = require('./coupon-tile');

const AMOUNT_TO_PRELOAD = 4;
function CouponsList({
  premium = [],
  coupons,
  routes,
  media = 'logo',
  color,
  referralSource = '',
}) {
  return h(
    '.coupons-list',
    premium.map(coupon =>
      h(
        '.coupons-list-row',
        CouponUber({
          coupon,
          routes: pruneData(
            routes,
            'outlink:main',
            'redemption:main',
            'redemption:terms'
          ),
          color,
          referralSource,
        })
      )
    ),
    coupons.map((coupon, index) =>
      h(
        '.coupons-list-row',
        CouponTile({
          coupon,
          media,
          routes: pruneData(
            routes,
            'outlink:main',
            'redemption:main',
            'redemption:terms',
            'merchant:show'
          ),
          lazy: index >= AMOUNT_TO_PRELOAD,
          color,
          referralSource,
        })
      )
    )
  );
}

module.exports = CouponsList;
